/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ReportDto } from '../models/report-dto';
import { reportsAckReport } from '../fn/reports/reports-ack-report';
import { ReportsAckReport$Params } from '../fn/reports/reports-ack-report';
import { reportsGetReports } from '../fn/reports/reports-get-reports';
import { ReportsGetReports$Params } from '../fn/reports/reports-get-reports';
import { reportsGetTypes } from '../fn/reports/reports-get-types';
import { ReportsGetTypes$Params } from '../fn/reports/reports-get-types';
import { reportsListReportsByPocId } from '../fn/reports/reports-list-reports-by-poc-id';
import { ReportsListReportsByPocId$Params } from '../fn/reports/reports-list-reports-by-poc-id';
import { reportsOpenPdf } from '../fn/reports/reports-open-pdf';
import { ReportsOpenPdf$Params } from '../fn/reports/reports-open-pdf';
import { ReportTypeDto } from '../models/report-type-dto';

@Injectable({ providedIn: 'root' })
export class ReportsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportsListReportsByPocId()` */
  static readonly ReportsListReportsByPocIdPath = '/api/reports/poc/{pocId}';

  /**
   * Get report IDs by poc ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsListReportsByPocId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsListReportsByPocId$Response(params: ReportsListReportsByPocId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    const obs = reportsListReportsByPocId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get report IDs by poc ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsListReportsByPocId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsListReportsByPocId(params: ReportsListReportsByPocId$Params, context?: HttpContext): Observable<Array<number>> {
    const resp = this.reportsListReportsByPocId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `reportsGetReports()` */
  static readonly ReportsGetReportsPath = '/api/reports/by-rmh-ids';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetReports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsGetReports$Response(params: ReportsGetReports$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    const obs = reportsGetReports(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetReports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsGetReports(params: ReportsGetReports$Params, context?: HttpContext): Observable<ReportDto> {
    const resp = this.reportsGetReports$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportsAckReport()` */
  static readonly ReportsAckReportPath = '/api/reports/ack';

  /**
   * Ack a report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAckReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsAckReport$Response(params: ReportsAckReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportsAckReport(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ack a report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAckReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsAckReport(params: ReportsAckReport$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportsAckReport$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsOpenPdf()` */
  static readonly ReportsOpenPdfPath = '/api/reports/pdf/{docId}';

  /**
   * Get PDF from ix.serv. Direct access to ix.serv's `/ixserv/doc/DocGenericReport?ixstoreDocId={docID}&compId=data&type=application/pdf`.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsOpenPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsOpenPdf$Response(params: ReportsOpenPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportsOpenPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get PDF from ix.serv. Direct access to ix.serv's `/ixserv/doc/DocGenericReport?ixstoreDocId={docID}&compId=data&type=application/pdf`.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsOpenPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsOpenPdf(params: ReportsOpenPdf$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportsOpenPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsGetTypes()` */
  static readonly ReportsGetTypesPath = '/api/reports/types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetTypes$Response(params?: ReportsGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportTypeDto>>> {
    const obs = reportsGetTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetTypes(params?: ReportsGetTypes$Params, context?: HttpContext): Observable<Array<ReportTypeDto>> {
    const resp = this.reportsGetTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReportTypeDto>>): Array<ReportTypeDto> => r.body)
    );
  }

}
